import { GroupShape, Shape, WallShape } from '../types';

export const calculateGroupBounds = (shapes: any[]) => {
  return shapes.reduce(
    (acc, shape) => {
      const shapeRight = shape.x + shape.width;
      const shapeBottom = shape.y + shape.height;

      acc.minX = Math.min(acc.minX, shape.x);
      acc.minY = Math.min(acc.minY, shape.y);
      acc.maxX = Math.max(acc.maxX, shapeRight);
      acc.maxY = Math.max(acc.maxY, shapeBottom);

      // Walls define their endpoint with x2/y2 which may extend beyond x+width
      if (shape.type === 'wall') {
        const wall = shape as WallShape;
        acc.minX = Math.min(acc.minX, wall.x2);
        acc.minY = Math.min(acc.minY, wall.y2);
        acc.maxX = Math.max(acc.maxX, wall.x2);
        acc.maxY = Math.max(acc.maxY, wall.y2);
      }

      return acc;
    },
    {
      minX: Number.POSITIVE_INFINITY,
      minY: Number.POSITIVE_INFINITY,
      maxX: Number.NEGATIVE_INFINITY,
      maxY: Number.NEGATIVE_INFINITY
    }
  );
};

export const flattenGroup = (
  group: GroupShape | Shape,
  parentX = 0,
  parentY = 0
): any[] => {
  if (group.type !== 'group') {
    const result: any = {
      ...group,
      x: parentX + group.x,
      y: parentY + group.y
    };
    if (group.type === 'wall') {
      result.x2 = parentX + (group as WallShape).x2;
      result.y2 = parentY + (group as WallShape).y2;
    }
    return [result];
  }

  return group.children.flatMap((child) =>
    flattenGroup(child, parentX + group.x, parentY + group.y)
  );
};
